module.exports = __webpack_public_path__ + "static/ribbon_import-67d00c8e5308441265363c0f37045ab2.png";